"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledToggleSwitch = exports.StyledText = exports.StyledCol = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _ToggleSwitch = require("../ToggleSwitch");
var _templateObject, _templateObject2, _templateObject3;
var disabledCursor = 'not-allowed !important';
var StyledCol = exports.StyledCol = (0, _styledComponents["default"])(_reactstrap.Col)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  white-space: pre-wrap;\n"])));
var StyledToggleSwitch = exports.StyledToggleSwitch = (0, _styledComponents["default"])(_ToggleSwitch.ToggleSwitch)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 24px;\n  .toggle-switch {\n    width: 28px;\n    height: 10px;\n  }\n\n  opacity: ", ";\n\n  cursor: ", ";\n\n  .slider {\n    cursor: ", ";\n  }\n  .slider:before {\n    width: 16px;\n    height: 16px;\n    bottom: -3px;\n    left: 0;\n  }\n\n  .slider.off:before {\n    border: 2px solid #8d91af;\n  }\n\n  .slider.on {\n    background: #0095ff;\n  }\n\n  .slider.on:before {\n    border: 2px solid #0095ff;\n  }\n"])), function (_ref) {
  var enableFeature = _ref.enableFeature;
  return enableFeature ? '' : '0.25';
}, function (_ref2) {
  var enableFeature = _ref2.enableFeature;
  return !enableFeature ? disabledCursor : 'pointer';
}, function (_ref3) {
  var enableFeature = _ref3.enableFeature;
  return !enableFeature ? disabledCursor : 'pointer';
});
var StyledText = exports.StyledText = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 8px;\n  font-size: ", ";\n  color: #000;\n  cursor: ", ";\n"])), function (_ref4) {
  var textSize = _ref4.textSize;
  return !!textSize ? "".concat(textSize, "px") : '14px';
}, function (_ref5) {
  var enableFeature = _ref5.enableFeature,
    labelCursor = _ref5.labelCursor;
  return !enableFeature ? disabledCursor : !!labelCursor ? labelCursor : 'pointer';
});